import gql from 'graphql-tag';

export default gql`
mutation deleteProjectTag($projectId: Int!, $tagId: Int!) {
  delete_projects_tags(where: {project_id: {_eq: $projectId}, tag_id: {_eq: $tagId}}) {
    affected_rows
  }
}
`;
